/*
 * @Author: Gang Jiang
 * @Date: 2026-05-25 11:08:09
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2026-05-25 15:53:30
 */

/** 接口未就绪时的演示数据 */
export const MOCK_REPORT_LIST = [
  {
    rowKey: '2023-10-27-88291',
    date: '2023-10-27',
    influencerUsername: 'luxe_lifestyle',
    influencerId: 88291,
    grossSales: 12450,
    commissions: 1867.5,
    clicks: 2480,
    cr: 4.2,
    trend: 12,
    advertiserCount: 2,
    advertisers: [
      {
        advertiserName: 'FashionHub Global',
        grossSales: 8200,
        commissions: 1230,
        clicks: 1600,
        cr: 5.1,
      },
      {
        advertiserName: 'BeautyCare Inc',
        grossSales: 4250,
        commissions: 637.5,
        clicks: 880,
        cr: 3.2,
      },
    ],
  },
  {
    rowKey: '2023-10-26-44102',
    date: '2023-10-26',
    influencerUsername: 'tech_guru_mike',
    influencerId: 44102,
    grossSales: 8900,
    commissions: 1335,
    clicks: 1950,
    cr: 3.8,
    trend: -4.5,
    advertiserCount: 1,
    advertisers: [
      {
        advertiserName: 'GadgetWorld',
        grossSales: 8900,
        commissions: 1335,
        clicks: 1950,
        cr: 3.8,
      },
    ],
  },
  {
    rowKey: '2023-10-25-77331',
    date: '2023-10-25',
    influencerUsername: 'home_decor_jen',
    influencerId: 77331,
    grossSales: 15200,
    commissions: 2280,
    clicks: 3100,
    cr: 5.1,
    trend: 8.2,
    advertiserCount: 3,
    advertisers: [
      {
        advertiserName: 'HomeStyle Co',
        grossSales: 7200,
        commissions: 1080,
        clicks: 1500,
        cr: 4.8,
      },
      {
        advertiserName: 'Luxe Living',
        grossSales: 5000,
        commissions: 750,
        clicks: 1000,
        cr: 5.5,
      },
      {
        advertiserName: 'Garden Plus',
        grossSales: 3000,
        commissions: 450,
        clicks: 600,
        cr: 5.0,
      },
    ],
  },
  {
    rowKey: '2023-10-24-88291',
    date: '2023-10-24',
    influencerUsername: 'luxe_lifestyle',
    influencerId: 88291,
    grossSales: 11200,
    commissions: 1680,
    clicks: 2200,
    cr: 4.0,
    trend: 0,
    advertiserCount: 2,
    advertisers: [
      {
        advertiserName: 'FashionHub Global',
        grossSales: 7000,
        commissions: 1050,
        clicks: 1400,
        cr: 4.2,
      },
      {
        advertiserName: 'BeautyBox Inc',
        grossSales: 4200,
        commissions: 630,
        clicks: 800,
        cr: 3.5,
      },
    ],
  },
]

export const MOCK_REPORT_SUMMARY = {
  grossSales: 312400,
  commissions: 42950,
  clicks: 84200,
  cr: 3.95,
}

export const MOCK_REPORT_TOTAL = 245

/** Advertiser 维度主表 mock */
export const MOCK_ADVERTISER_REPORT_LIST = [
  {
    rowKey: 'adv-2023-10-27-101',
    date: '2023-10-27',
    advertiserName: 'FashionHub Global',
    advertiserId: 101,
    grossSales: 12450,
    commissions: 1867.5,
    clicks: 2480,
    cr: 4.2,
    trend: 12,
    influencerCount: 2,
    influencers: [
      {
        influencerUsername: 'luxe_lifestyle',
        influencerId: 88291,
        grossSales: 8200,
        commissions: 1230,
        clicks: 1600,
        cr: 5.1,
      },
      {
        influencerUsername: 'style_queen',
        influencerId: 88292,
        grossSales: 4250,
        commissions: 637.5,
        clicks: 880,
        cr: 3.2,
      },
    ],
  },
]

export const MOCK_ADVERTISER_REPORT_TOTAL = 48
